import { Suspense } from 'react'

import { ExploreMain } from './ExploreMain'
import FeaturedEvent from './FeaturedEvent'
import { Filter } from './Filter'

export const EventsExplore: React.FC = () => {
  return (
    <div className="relative wrapper mb-12">
      <h1 className="mt-6 mb-5 font-display text-5xl font-normal text-foreground lg:mb-10 lg:text-6xl xl:text-7xl">
        Events
      </h1>
      <Suspense fallback={<div>Loading...</div>}>
        <FeaturedEvent />
      </Suspense>
      <div className="relative z-30 grid grid-cols-1 gap-4 lg:grid-cols-[minmax(324px,340px)_minmax(0,1fr)] lg:grid-rows-[auto_40px] lg:gap-5 xl:gap-8">
        <Suspense fallback={<div>Loading...</div>}>
          <Filter />
        </Suspense>

        <Suspense fallback={<div>Loading...</div>}>
          <ExploreMain />
        </Suspense>
      </div>
    </div>
  )
}
